import { createFileRoute } from "@tanstack/react-router";
import { PointsHelpTemplate } from "~/features/myProfile/PointsHelpTemplate";
import { getPointsHelpColors } from "~/features/myProfile/pointsHelpColors";

// MyProfileTemplate（layout）の上に全画面オーバーレイで重ねる
const PointsHelpPage = () => (
  <div className={`fixed inset-0 z-40 ${getPointsHelpColors().overlayBg}`}>
    <PointsHelpTemplate />
  </div>
);

export const Route = createFileRoute("/_authenticated/my-page/points-help")({
  component: PointsHelpPage,
});
